import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=6bd5b924&scoped=true&"
var script = {}
import style0 from "./LoginFooter.vue?vue&type=style&index=0&id=6bd5b924&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5b924",
  null
  
)

export default component.exports